export * from './es5/index.js';


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/rdav/web/app/themes/rdav/node_modules/ionicons/dist/esm/index.js
// module id = 4
// module chunks = 0